import { render, staticRenderFns } from "./PopUp.vue?vue&type=template&id=45b6f734&"
import script from "./PopUp.vue?vue&type=script&lang=ts&"
export * from "./PopUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports